module.exports = __webpack_public_path__ + "img/2.a654496a.jpg";